import productClassificationLabelsFrJson from './i18n/fr/product-classification.json' with { type: 'json' };
import productClassificationTagLabelsFrJson from './i18n/fr/product-classification-tags.json' with { type: 'json' };

export const productClassificationLabelsFr: Record<string, string> = productClassificationLabelsFrJson;
export const productClassificationTagLabelsFr: Record<string, string> = productClassificationTagLabelsFrJson;
